module.exports = __webpack_public_path__ + "static/media/Fee.b25b8178.svg";